import { toastr } from 'react-redux-toastr';
import { REVIEWS_ACTION_TYPES } from './actionTypes';
import { reviewsApi } from './api';
import { reviewsSelectors } from './selectors';

const REVIEWS_PER_PAGE = 20;

export const reviewsActions = {
    fetchListRequest: (productId) => ({
        type: REVIEWS_ACTION_TYPES.FETCH_LIST_REQUEST,
        payload: { productId },
    }),

    fetchListSuccess: (productId, data, page, hasMore, totalReviews) => ({
        type: REVIEWS_ACTION_TYPES.FETCH_LIST_SUCCESS,
        payload: { productId, data, page, hasMore, totalReviews },
        meta: { timestamp: Date.now() },
    }),

    fetchListFailure: (productId, error) => ({
        type: REVIEWS_ACTION_TYPES.FETCH_LIST_FAILURE,
        payload: { productId, error },
        error: true,
    }),
}


export const fetchReviewsList = (productId, page = 1) => {
    return async (dispatch, getState) => {
        const state = getState().reviews;
        const productData = state.reviewsByProductId[productId];

        if (productData && productData.loading) {
            return;
        }

        dispatch(reviewsActions.fetchListRequest(productId));

        try {
            const response = await reviewsApi.fetchList({
                page: page,
                per_page: REVIEWS_PER_PAGE
            }, productId);

            const data = response.data || [];

            const hasMore = data.length === REVIEWS_PER_PAGE;
            const totalReviews = 0;

            dispatch(reviewsActions.fetchListSuccess(productId, data, page, hasMore, totalReviews));
        } catch (error) {
            console.error('Ошибка загрузки отзывов:', error);
            dispatch(reviewsActions.fetchListFailure(productId, error.message || 'Не удалось загрузить отзывы'));
            toastr.error('Ошибка', 'Не удалось загрузить отзывы для товара');
        }
    };
};


export const fetchNextReviewsPage = (productId) => {
    return (dispatch, getState) => {
        const state = getState();

        const hasMore = reviewsSelectors.selectReviewsHasMore(state, productId);
        const isLoading = reviewsSelectors.selectIsReviewsLoading(state, productId);
        const currentPage = reviewsSelectors.selectReviewsCurrentPage(state, productId);

        if (hasMore && !isLoading) {
            dispatch(fetchReviewsList(productId, currentPage + 1));
        }
    };
};